import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';
import webClient from '../../core/web_client';
import { buildQueryString, extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { WAREHOUSES_PATH } from '../../core/constants';

export const getWarehouseProductBatchesAction = createAsyncThunk(
    'inventory/getWarehouseProductBatchesAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ WAREHOUSES_PATH }/${ data.sourceWarehouseId }/product-batches${ buildQueryString(data.query) }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getWarehouseProductBatchesSlice = createSlice({
    name: 'getWarehouseProductBatchesSlice',
    initialState: DEFAULT_STATE,
    reducers: {
        invalidateProductBatches() {
            return DEFAULT_STATE;
        }
    },
    extraReducers: builder => {
        builder.addCase(getWarehouseProductBatchesAction.pending, () => STATE__API__STARTED);
        builder.addCase(getWarehouseProductBatchesAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getWarehouseProductBatchesAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const { invalidateProductBatches } = getWarehouseProductBatchesSlice.actions;
export const getWarehouseProductBatchesState = (state) => state.inventory.getWarehouseProductBatches;
export default getWarehouseProductBatchesSlice.reducer;